import type { XmaxOpenClient } from '../api/client'
import { toXmaxSdkError, XmaxSdkError } from '../shared/sdk-error'

export async function resolveRefImageUrl(
  client: XmaxOpenClient,
  input: File | string,
): Promise<string> {
  if (input instanceof File) {
    return (await client.uploadImage(input)).url
  }

  const raw = input.trim()
  if (!raw) {
    return ''
  }

  if (/^https?:\/\//i.test(raw)) {
    return raw
  }

  let res: Response
  try {
    res = await fetch(raw)
  } catch (error) {
    throw toXmaxSdkError(error, {
      code: 'MEDIA_PROCESSING_ERROR',
      message: 'Failed to load ref image',
    })
  }
  if (!res.ok) {
    throw new XmaxSdkError('MEDIA_PROCESSING_ERROR', `Failed to load ref image: ${res.status}`)
  }

  let blob: Blob
  try {
    blob = await res.blob()
  } catch (error) {
    throw toXmaxSdkError(error, {
      code: 'MEDIA_PROCESSING_ERROR',
      message: 'Failed to read ref image response',
    })
  }
  const mime = blob.type || 'image/png'
  const ext =
    mime === 'image/jpeg' ? 'jpg' :
    mime === 'image/webp' ? 'webp' :
    mime === 'image/gif' ? 'gif' :
    'png'
  const file = new File([blob], `ref.${ext}`, { type: mime })
  return (await client.uploadImage(file)).url
}
